import React, { useState } from "react";
import { Button, Input, Modal, ModalBody, ModalHeader } from "reactstrap";
import { AmcVisit } from "features/AmcVisitLogs/types/amc-visit.types";

interface CancelModalProps {
  show?: boolean;
  onCancelClick?: (reason?: string) => void;
  onCloseClick?: () => void;
  record?: AmcVisit | null;
}

const CancelModal = ({
  show,
  onCancelClick,
  onCloseClick,
  record,
}: CancelModalProps) => {
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setReason("");
    onCloseClick?.();
  };

  const handleConfirm = () => {
    onCancelClick?.(reason.trim() || undefined);
    setReason("");
  };

  return (
    <React.Fragment>
      <Modal fade={true} isOpen={show} toggle={handleClose} centered>
        <ModalHeader className="modal-title">#{record?.code}</ModalHeader>
        <ModalBody className="text-center p-5">
          <i className="ri-close-circle-line display-5 text-danger"></i>
          <div className="mt-4">
            <h4 className="mb-3">Cancel Service Visit</h4>
            <p className="text-muted mb-4">
              Are you sure you want to cancel this visit? This action cannot be
              undone.
            </p>
            <Input
              type="textarea"
              rows={3}
              className="form-control mb-3 text-start"
              placeholder="Reason for cancellation (optional)"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
            <div className="hstack gap-2 justify-content-center">
              <Button color="light" onClick={handleClose}>
                No, Go Back
              </Button>
              <Button color="danger" onClick={handleConfirm}>
                Yes, Cancel Visit
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default CancelModal;
